module.exports = __webpack_public_path__ + "static/media/full-screen-icon.5d30663f.svg";